import React from 'react'
import { Select } from 'antd'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

interface Props {
  field: any
  form: any
}

const Language = (props: Props): JSX.Element => {
  const { t } = useTranslation()

  const { Option } = Select

  return (
    <Wrapper>
      <label>{t('language.label')}</label>
      <Select
        style={{ width: '100%' }}
        onChange={e => {
          props.form.setFieldValue(props.field.name, e)
        }}
        defaultValue={props.form.initialValues.language}
      >
        <Option key={'FR'} value={'French'}>
          {'Français'}
        </Option>
        <Option key={'EN'} value={'English'}>
          {'Anglais'}
        </Option>
        <Option key={'ZH'} value={'Chinese'}>
          {'Chinois'}
        </Option>
      </Select>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  margin-top: 25px;
`

export default Language
